import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';


@Component({
  selector: 'app-conflicts',
  templateUrl: './conflicts.component.html',
  styleUrls: ['./conflicts.component.scss']
})
export class ConflictsComponent {

  public currentTab: string = 'upComing';
  public conflictArr:any [] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private recruiterService: RecruiterService,
    private commonService: CommonService,
    private dialogRef:MatDialogRef<ConflictsComponent>,
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.getConflictList()
  }

  onTabChange(value) {
    this.currentTab = value;
  }

  getConflictList() {

    let data = {
      "st_dt": this.data.startDate,
      "ed_dt": this.data.endDate,
      "type": "1"
    }

    this.recruiterService.getConflictList(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.conflictArr = success.msg;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  onClose(){
    this.dialogRef.close()
  }
}
